import React, { useEffect, useState } from "react";
import { Fragment } from "react";

import Pagina from "../comun/Pagina";
import SelectorSismosGrande from "./SelectorSismosGrande";
import Resultados from "./Resultados";

import mundo from '../../img/mundo.png';

export default function SelectorResultadosSismo(props) {
    const [idSismo, setIdSismo] = useState(null);
    
    if (idSismo == null) {
        return (
        <Fragment>
            <div className="Formulario">
                <div className="BarraTitulo">{props.titulo}</div>
                <div className="BarraDibujo">
                    <img src={mundo} alt="Seleccionar sismo" height="80"/>
                </div>
                <div className="BarraExplicacion">            
                    En el siguiente listado se presentan los sismos sentidos y sus intensidades en el territorio nacional, ocurridos desde octubre de 2009. 
                    <br/>
                    En “Consulta por sitio” es posible consultar las intensidades evaluadas en un centro poblado espec&iacute;fico.
                </div>
                <div className="ContenidoPrincipal">
                    <div className="TextoMedianoVerde">Selecciona el sismo del siguiente listado</div>
                    <SelectorSismosGrande
                    setIdSismo={setIdSismo}
                    setPagina={props.setPagina}
                    />
                </div>
                <div className="ContenedorH">
                    <button                     
                    className="BotonAvanzar"                   
                    onClick={props.irAConsultaSitio}>
                        Consulta por sitio
                    </button>
                    &nbsp;
                    <button 
                    className="BotonAvanzar"
                    onClick={props.irAPagina0}>
                        Reportar sismo
                    </button>
                </div>
            </div>
        </Fragment>
        );
    } else {
        return (
            <Resultados idSismo={idSismo} irAPagina0={props.irAPagina0}/>
        );
    }
}